module.exports = __webpack_public_path__ + "static/FRONTAL-371e27600efdc61811a1f16c4ce30bd7.webp";